import { useDispatch } from 'react-redux';

import { ClickToCallStatusInputDto, ClickToCallStatusOutputDto } from '@api/ecommerce-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchClickToCallStatus = (): UseFetchHookOutput<
	Omit<ClickToCallStatusInputDto, 'metadata'>,
	ClickToCallStatusOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<ClickToCallStatusInputDto, ClickToCallStatusOutputDto>({
		operationKey: 'clickToCallStatus',
		withLoading: false,
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ clickToCallStatus: res.data }));
			}
		},
	});
};
